/**
 * A function that just takes the input template string and combines it, and sends it out again
 */
export default function gql(strings: TemplateStringsArray, ...expr: string[]) {
  let str = '';
  strings.forEach((string, i) => {
    str += string + (expr[i] || '');
  });
  const trimmed = str.trim();

  return trimmed;
}
